export default {
  introSteps: {
    exportFile: 'Izvezite istraživanje bez podataka sa drugog Arena servera (npr. Dev ili QA)',
    selectFile: 'Izaberite izvezeni fajl (.zip): upoređuje se sa ovim istraživanjem i prikazuju se razlike',
    applyChanges:
      'Pregledajte razlike i primijenite izabrane izmjene na ovo istraživanje (brisanja nikada nisu podrazumijevano izabrana)',
    publish: 'Izmjene se čuvaju kao nacrt: testirajte obrazac i objavite istraživanje da bi izmjene stupile na snagu',
  },
  fileTooLarge:
    'Izabrani fajl je prevelik (najviše {{maxSize}} MB): izvezite istraživanje bez podataka, zapisi i njihovi fajlovi nisu potrebni za upoređivanje istraživanja',
  selectNewSource: 'Izaberi novi izvor',
  selectNewSourceInfo: 'Odbaci ovo upoređivanje i izaberi drugi fajl istraživanja ili istraživanje',
  refreshComparison: 'Osvježi upoređivanje',
  refreshComparisonInfo: 'Ponovo uporedi isti fajl sa trenutnom verzijom ovog istraživanja (npr. nakon uređivanja)',
  sourceSurvey: 'Upoređeno istraživanje: {{name}}',
  compareWithSurvey: 'Ili uporedite sa drugim istraživanjem na ovom serveru:',
  fingerprint: {
    thisSurvey: 'Ovo istraživanje',
    comparedSurvey: 'Upoređeno istraživanje',
    equal: 'Isto kao ovo istraživanje',
    different: 'Razlikuje se od ovog istraživanja',
    label: 'Otisak',
    structural: 'strukturni',
    info: 'Otisci definicije istraživanja (nacrt). Jednaki otisci znače jednake definicije. Prvi uključuje interne ID-jeve: jednak je samo za kopije istog istraživanja (npr. izvezenog i uvezenog na drugom serveru). Strukturni koristi nazive i šifre: jednak je i za istraživanja kreirana zasebno sa istom strukturom. Nazivi, oznake, ID-jevi, datumi i status objavljivanja nisu dio otiska.',
    copy: 'Kopiraj cijeli otisak: {{value}}',
    copied: 'Otisak je kopiran u međuspremnik',
  },
  identical: 'Istraživanja su identična',
  counts: 'Samo u upoređenom istraživanju: {{added}}, izmijenjeno: {{changed}}, samo u ovom istraživanju: {{removed}}',
  surveyInfoChanged:
    'Informacije o istraživanju (jezici, ciklusi, oznake) se razlikuju: pogledajte karticu "Informacije o istraživanju"',
  onlyDifferences: 'Prikaži samo razlike',
  hideLayoutOnly: 'Sakrij razlike samo u rasporedu',
  apply: 'Primijeni izabrane izmjene ({{count}})',
  applyConfirm: `Primijeniti izabrane izmjene ({{count}}) na ovo istraživanje?
Izmjene se čuvaju kao nacrt: zapisi će ih dobiti tek kada istraživanje bude objavljeno.`,
  willBeDeleted: 'biće obrisano',
  removedNodeDefInfo:
    'Ova definicija čvora postoji samo u ovom istraživanju: primjenom ove izmjene ona se briše (zajedno sa svojim potomcima) iz ovog istraživanja.',
  removedItemInfo: 'Samo u ovom istraživanju: primjenom ove izmjene briše se iz ovog istraživanja.',
  applyConfirmWithDeletionsHeader: 'Potvrdite brisanja',
  applyConfirmWithDeletions:
    'Primijeniti izabrane izmjene ({{count}}) na ovo istraživanje?\n\n**Od toga {{deletionsCount}} briše elemente ovog istraživanja** (elemente koji nisu u upoređenom istraživanju):\n\n{{- deletions}}\n\n$t(common.cantUndoWarning)',
  applyWithDeletions: 'Primijeni i obriši',
  confirmSurveyName: 'Unesite naziv ovog istraživanja da potvrdite:',
  deletionOfItemsOf: 'elementi samo u ovom istraživanju za **{{name}}**',
  moreDeletions: '... i još {{count}}',
  applyCompleted:
    'Primijenjeno izmjena: {{applied}}, preskočeno: {{skipped}}. Objavite istraživanje da bi stupile na snagu.',
  tabs: {
    nodeDefs: 'Definicije čvorova',
    categories: 'Kategorije',
    taxonomies: 'Taksonomije',
    surveyInfo: 'Informacije o istraživanju',
    surveyFiles: 'Fajlovi',
  },
  status: {
    added: 'Samo u upoređenom istraživanju',
    changed: 'Izmijenjeno',
    removed: 'Samo u ovom istraživanju',
  },
  statusLabel: 'Status',
  matchedBy: {
    uuid: 'Upareno po internom ID-ju',
    name: 'Upareno po nazivu (interni ID-jevi se razlikuju)',
    manual: 'Upareno ručno: primjenjuje se kao preimenovanje',
  },
  renameCandidate: 'Moguće je da je to preimenovani "{{name}}" iz ovog istraživanja',
  possibleRename: 'moguće preimenovanje',
  matchAsRename: 'Upari kao preimenovano',
  unmatch: 'Poništi uparivanje',
  props: {
    branding: 'Vizuelni identitet',
    columnsNo: 'Kolone',
    columnsOrder: 'Redoslijed kolona',
    cycles: 'Ciklusi',
    defaultCycleKey: 'Podrazumijevani ciklus',
    descriptions: 'Opisi',
    extra: 'Dodatna svojstva',
    family: 'Familija',
    fieldManualLinks: 'Linkovi ka terenskom priručniku',
    formLayout: 'Raspored obrasca',
    genus: 'Rod',
    gridPosition: 'red {{row}}, kolona {{column}}, širina {{width}}, visina {{height}}',
    itemExtraDef: 'Dodatna svojstva',
    keepNonApplicableValues: 'Zadrži vrijednosti koje nisu primjenjive',
    labels: 'Oznake',
    languages: 'Jezici',
    layout: 'Raspored',
    levels: 'Nivoi',
    messages: 'Poruke',
    pagesOrder: 'Redoslijed stranica',
    parent: 'Nadređeni entitet',
    preloadedMapLayersEnabled: 'Unaprijed učitani slojevi mape omogućeni',
    reportingData: 'Podaci za izvještavanje',
    sampleBasedImageInterpretationEnabled: 'Interpretacija snimaka zasnovana na uzorku',
    samplingPolygon: 'Poligon uzorkovanja',
    scientificName: 'Naučni naziv',
    size: 'Veličina',
    srs: 'Prostorni referentni sistemi',
    surveyDocOptions: 'Opcije dokumentacije istraživanja',
    userExtraPropDefs: 'Dodatna svojstva korisnika',
    validations: 'Validacije',
    vernacularLanguageCodes: 'Jezici narodnih naziva',
    vernacularNames: 'Narodni nazivi',
  },
  fileTypes: {
    preloadedMapLayer: 'Unaprijed učitani sloj mape',
    surveyDocImage: 'Slika dokumentacije istraživanja',
    brandingSurveyLogo1: 'Logo istraživanja 1',
    brandingSurveyLogo2: 'Logo istraživanja 2',
    brandingSurveyLogo3: 'Logo istraživanja 3',
    brandingLandingBackground: 'Pozadina početne stranice',
  },
  cycle: 'ciklus {{cycle}}',
  property: 'Svojstvo',
  sourceValue: 'Upoređeno istraživanje',
  targetValue: 'Ovo istraživanje',
  emptyValue: '(prazno)',
  layoutOnly: 'samo raspored',
  selectItem: 'Izaberite stavku da vidite detalje',
  noDifferences: 'Nema razlika',
  identicalItem: 'Nema razlika',
  dependsOn: 'Primjenjuje se zajedno sa:',
  itemsCount: 'stavke: dodato {{added}}, izmijenjeno {{changed}}, samo u ovom istraživanju {{removed}}',
  itemCode: 'Šifra',
  taxaCount: 'taksoni: dodato {{added}}, izmijenjeno {{changed}}, samo u ovom istraživanju {{removed}}',
  taxonCode: 'Šifra',
  changes: 'Izmjene',
  moreItems: '... i još {{count}} stavki',
  categoryRemoval: 'Obriši stavke (i nivoe) koji postoje samo u ovom istraživanju',
  taxonomyRemoval: 'Obriši taksone i narodne nazive koji postoje samo u ovom istraživanju',
  removalSelected: 'brisanje izabrano',
  publishedKept: '(objavljeno: zadržano)',
  reasons: {
    categoryInUse: 'Kategoriju koriste definicije čvorova koje nisu obrisane',
    categoryMissing: 'Kategorija ne postoji u ovom istraživanju',
    cycleMissing: 'Neki ciklus ne postoji u ovom istraživanju',
    dependencyNotApplicable: 'Izmjena od koje zavisi ne može se primijeniti',
    parentMissing: 'Nadređena definicija čvora ne postoji u ovom istraživanju',
    publishedCategoryChanged: 'Kategorija objavljene definicije čvora ne može se mijenjati',
    publishedKeyChanged: 'Svojstvo "ključ" objavljene definicije čvora ne može se mijenjati',
    publishedMoveNotSupported: 'Objavljena definicija čvora ne može se premjestiti u drugi entitet',
    publishedMultipleChanged: 'Svojstvo "višestruko" objavljene definicije čvora ne može se mijenjati',
    publishedTaxonomyChanged: 'Taksonomija objavljene definicije čvora ne može se mijenjati',
    publishedTypeChanged: 'Tip objavljene definicije čvora ne može se mijenjati',
    taxonomyInUse: 'Taksonomiju koriste definicije čvorova koje nisu obrisane',
    taxonomyMissing: 'Taksonomija ne postoji u ovom istraživanju',
    nodeDefUsedByOthers: 'Druge definicije čvorova je koriste u svojim izrazima: ažurirajte i njih',
    publishedCategoryItemsKept: 'Objavljene stavke ne mogu se obrisati: zadržavaju se',
    publishedCategoryLevelsKept: 'Objavljeni nivoi ne mogu se obrisati: zadržavaju se',
    publishedCyclesRemoved: 'Uklanjanjem ciklusa iz objavljene definicije čvora brišu se njeni podaci u tim ciklusima',
    publishedLanguagesRemoved: 'Uklanjanjem jezika brišu se njihove oznake kada se istraživanje objavi',
    publishedNameChanged:
      'Preimenovanje objavljene definicije čvora: izrazi koji koriste stari naziv moraju se ažurirati',
    publishedNodeDefDeleted: 'Definicija čvora je objavljena: njeni podaci biće obrisani kada se istraživanje objavi',
    publishedSurveyCyclesRemoved: 'Uklanjanjem ciklusa brišu se njihovi zapisi kada se istraživanje objavi',
    publishedTaxaKept: 'Objavljeni taksoni ne mogu se obrisati: zadržavaju se',
    publishedVernacularNamesKept: 'Objavljeni narodni nazivi ne mogu se obrisati: zadržavaju se',
  },
}
